import { useState } from "react";
import Graph from "./Graph";

const GraphDesign = () => {
  const [tasksViewMode, setTasksViewMode] = useState("daily");

  return (
    <div className="w-full mb-5">
      <div className="bg-white shadow rounded-lg p-6">
        
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4">
          <h5 className="text-lg font-semibold mb-2 md:mb-0">Task Activities</h5>
          <div className="w-full md:w-48">
            <select
              className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              value={tasksViewMode}
              onChange={(e) => setTasksViewMode(e.target.value)}
            >
              <option value="daily">Last Week</option>
              <option value="monthly">Last Month</option>
              <option value="sixMonths">Last 6 Months</option>
              <option value="yearly">Last 1 Year</option>
            </select>
          </div>
        </div>

        
        <div className="w-full">
          <Graph tasksViewMode={tasksViewMode} />
        </div>
      </div>
    </div>
  );
};

export default GraphDesign;
